import React, { useState, useEffect } from "react";
import StickySidebar from "accountOwner/pages/Scheduler/components/StickySidebar";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { withTranslation } from "react-i18next";
import moment from "moment";
import styles from "../../../AddEvent.module.scss";
import OfficeRoleShedulingFilter from "./OfficeRoleShedulingFilter";
import { useAllStaffByDesignationIdAndOfficeId } from "repositories/notes-repository";
import {
  useAllActiveOffices,
  useStaffDesignation,
} from "repositories/scheduler-repository";
import AgendaFilter from "accountOwner/pages/Scheduler/components/SchedulerFilters/AgendaFilter";
import constants from "../../../../../../constants";
import { getHolidayList } from "actions";
import { useDispatch, useSelector } from "react-redux";
import SchedulerCalendar from "accountOwner/pages/Scheduler/components/SchedulerCalendar";
import { filteringMethodForEventShiftOthers } from "accountOwner/pages/Scheduler/scheduler.function";

const SchedulingAssistentFilter = ({
  t,
  handleSidebarToggle,
  isSidebarActive,
  eventDate,
  setEventDate,
  ownerId,
  eventOrShiftTab,
  selectedStaff,
  setSelectedStaff,
  onApplyStaff,
  filterEventsData,
  viewSettingFilterOptions,
  agendaTypes,
  setAgendaTypes,
  viewSettig,
  setViewSetting,
  setAgendaFilter,
  setSettingFilter,
  assistantViewSelected,
  setAgendaFilteredData,
  agenda,
  setShowFreeSlots,
  setShowFindAvailabilityButtons,
  setCheckFreeSlotAfterFilterApply,
}) => {
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedRoleOption, setSelectedRoleOption] = useState({
    value: "",
    label: "All Roles",
  });
  const [search, setSearch] = useState("");
  const [filteredStaff, setFilteredStaff] = useState([]);
  const [hasStaffChanged, setHasStaffChanged] = useState(false);
  const [activeStartDate, setActiveStartDate] = useState(
    eventDate
      ? eventDate instanceof Date
        ? eventDate
        : new Date(eventDate)
      : new Date(),
  );
  const { isLoading: loadingRoleData, data: staffRoleData } =
    useStaffDesignation();
  const { isLoading: officeDataLoading, data: officeData } =
    useAllActiveOffices(1, constants.ACTIVE_OFFICES_PAGE_SIZE, ownerId);
  const dispatch = useDispatch();

  const rolesData =
    staffRoleData
      ?.map((item) => item?.designations)
      ?.flat()
      ?.map((item) => ({ label: item?.name, value: item?.id })) || [];

  const holidayDates = useSelector((state) => state?.holiday?.holidayList);

  const [selectedOfficeOption, setSelectedOfficeOption] = useState({
    value: "",
    label: "All Offices",
  });
  const [selectedOffice, setSelectedOffice] = useState([]);
  const [officeList, setOfficeList] = useState([]);

  useEffect(() => {
    if (eventDate) {
      fetchHolidayDates();
    }
  }, [eventDate]);

  useEffect(() => {
    if (!officeDataLoading && officeData?.data?.length) {
      const formattedData = officeData.data.map((item) => ({
        label: item?.name,
        value: item?.id,
      }));
      setOfficeList([{ value: "", label: "All Offices" }, ...formattedData]);
    }
  }, [officeDataLoading, officeData]);

  const fetchHolidayDates = () => {
    try {
      const payload = {
        year: moment(eventDate).format("YYYY"),
        month: moment(eventDate).format("MM"),
        OwnerId: ownerId || "",
      };

      dispatch(getHolidayList(payload));
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleRoleChange = (selected) => {
    setSelectedRoleOption(selected);
    setSelectedRoles(selected?.value ? [selected.value] : []);
    setSearch("");
  };

  const handleOfficeChange = (selected) => {
    setSelectedOfficeOption(selected);
    setSelectedOffice(selected?.value ? [selected.value] : []);
    setSearch("");
  };

  // Data fetching
  const { data: staffData, isLoading: staffLoading } =
    useAllStaffByDesignationIdAndOfficeId(
      selectedRoles,
      selectedOffice,
      { ownerId, IsOwnerInclude: true },
      { enabled: !!ownerId },
    );

  // Filter staff list by search
  useEffect(() => {
    if (staffData?.data) {
      const trimmedSearchValue = search.replace(/\s+/g, "").toLowerCase();
      let filterArray = staffData.data.filter((item) => {
        const fullName =
          `${item?.user?.firstName}${item?.user?.lastName}`.toLowerCase();
        return fullName.includes(trimmedSearchValue);
      });
      // Office filter is already applied by API, but if needed, filter here as well
      if (selectedOfficeOption.value) {
        filterArray = filterArray.filter(
          (item) =>
            String(item.officeId) === String(selectedOfficeOption.value),
        );
      }
      setFilteredStaff(filterArray);
    } else {
      setFilteredStaff([]);
    }
  }, [staffData, search, selectedOfficeOption]);

  // Update activeStartDate when eventDate changes from parent
  useEffect(() => {
    if (eventDate) {
      setActiveStartDate(
        eventDate instanceof Date ? eventDate : new Date(eventDate),
      );
    }
  }, [eventDate]);

  useEffect(() => {
    setHasStaffChanged(true);
  }, [selectedStaff]);

  const filterByEvents = () => {
    const updatedAgenda = agenda?.map((item) =>
      filteringMethodForEventShiftOthers(agendaTypes, item, ownerId),
    );

    setAgendaFilter(updatedAgenda);
  };

  const scrollToElement = () => {
    const element = document.getElementById("targetElementId");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    }
  };

  const handleApply = () => {
    scrollToElement();

    if (typeof onApplyStaff === "function") {
      onApplyStaff();

      if (hasStaffChanged) {
        setCheckFreeSlotAfterFilterApply(true);
        setHasStaffChanged(false);
      }
    }

    if (agendaTypes?.length > 0) {
      filterByEvents();
      setAgendaFilteredData(agendaTypes);
    } else {
      setAgendaFilter(agenda);
    }

    if (viewSettig?.length > 0) {
      setSettingFilter(() => {
        // Allow staffMembers for Monthly (3), Daily (4), Weekly (5)
        if (
          assistantViewSelected === "3" ||
          assistantViewSelected === "4" ||
          assistantViewSelected === "5"
        ) {
          return viewSettig;
        }
        return viewSettig.filter((type) => type !== "staffMembers");
      });
    } else {
      setSettingFilter([]);
    }

    const mediaQuery = window.matchMedia("(max-width: 767px)");
    if (mediaQuery.matches) handleSidebarToggle();
  };

  const handleReset = () => {
    scrollToElement();
    setSettingFilter([]);
    setViewSetting([]);
    setAgendaTypes([]);
    setAgendaFilter(agenda);
    setAgendaFilteredData([]);
    setSelectedRoles([]);
    setSelectedRoleOption({ value: "", label: "All Roles" });
    setSelectedOfficeOption({ value: "", label: "All Offices" });
    setSelectedOffice([]);
    setSearch("");
    const mediaQuery = window.matchMedia("(max-width: 767px)");
    if (mediaQuery.matches) handleSidebarToggle();
  };

  const onChange = (date) => {
    if (setEventDate) setEventDate(date);
    setActiveStartDate(date);
    setShowFreeSlots(false);
    setShowFindAvailabilityButtons(false);
  };

  const getTileClassName = ({ date, view }) => {
    if (view !== "month") return "";
    const dateStr = moment(date).format("YYYY-MM-DD");
    const selectedStr = eventDate
      ? moment(eventDate).format("YYYY-MM-DD")
      : null;
    const todayStr = moment().format("YYYY-MM-DD");
    const isSelected = selectedStr === dateStr;
    const isHoliday = holidayDates?.some(
      (item) => moment(item.date).format("YYYY-MM-DD") === dateStr,
    );
    const isToday = dateStr === todayStr;
    return [
      styles.calendar_tile,
      isSelected ? styles.selected : "",
      isHoliday ? styles.holiday : "",
      isToday ? "current_day" : "",
    ].join(" ");
  };

  const onSearch = (e) => {
    setSearch(e.target.value);
  };

  const onActiveStartDateChange = (value) => {
    if (
      constants.calanderActions.includes(value?.action) ||
      (value?.action === constants.calanderActionKey.drillDown &&
        (value?.view === "month" || value?.view === "year"))
    ) {
      value?.activeStartDate && setEventDate(value.activeStartDate);
      setActiveStartDate(value.activeStartDate);
      setShowFreeSlots(false);
      setShowFindAvailabilityButtons(false);
    }
  };

  const isFilterApply = agendaTypes?.length || viewSettig?.length;

  const renderCalendarSection = () => {
    return (
      <>
        <div className={styles.create_event_calendar}>
          <SchedulerCalendar
            onChange={onChange}
            className={`scheduler-calendar mb-0`}
            tileClassName={getTileClassName}
            value={
              eventDate
                ? eventDate instanceof Date
                  ? eventDate
                  : new Date(eventDate)
                : null
            }
            activeStartDate={activeStartDate}
            onActiveStartDateChange={onActiveStartDateChange}
            minDate={new Date()}
            showTodayButton={true}
            onTodayClick={() => {
              if (setEventDate) setEventDate(new Date());
              setActiveStartDate(new Date());
              setShowFreeSlots(false);
              setShowFindAvailabilityButtons(false);
            }}
          />
        </div>
        <div className={styles.blue_green_box_wrapper}>
          <div className={styles.color_box_container}>
            <div className={styles.box_blue} />{" "}
            <p className={styles.current_text}>Current Day</p>
          </div>
          <div className={styles.color_box_container}>
            <div className={styles.box_green} />{" "}
            <p className={styles.current_text}>Holiday</p>
          </div>
        </div>
      </>
    );
  };

  const renderFilterSection = () => {
    return (
      <>
        <p className={styles.notes_filter}>
          {t("notes.filters")}
          {!!isFilterApply && <span className={styles.red_dot}></span>}
        </p>
        <Accordion
          preExpanded={["a"]}
          className="filter-accordion"
          allowZeroExpanded
          allowMultipleExpanded
        >
          <AccordionItem uuid="a">
            <AccordionItemHeading>
              <AccordionItemButton>{t("staffMembers")}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <OfficeRoleShedulingFilter
                rolesData={[{ value: "", label: "All Roles" }, ...rolesData]}
                selectedRoleOption={selectedRoleOption}
                handleRoleChange={handleRoleChange}
                officeList={officeList}
                selectedOfficeOption={selectedOfficeOption}
                handleOfficeChange={handleOfficeChange}
                staffData={filteredStaff}
                staffLoading={staffLoading}
                loadingRoleData={loadingRoleData}
                search={search}
                onSearch={onSearch}
                eventOrShiftTab={eventOrShiftTab}
                selectedStaff={selectedStaff}
                setSelectedStaff={setSelectedStaff}
              />
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem uuid="c">
            <AccordionItemHeading>
              <AccordionItemButton>{t("Event/Shift")}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <AgendaFilter
                setAgendaTypes={setAgendaTypes}
                agendaTypes={agendaTypes}
                FilterEventsData={filterEventsData}
              />
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem uuid="d">
            <AccordionItemHeading>
              <AccordionItemButton>
                {t("accountOwner.viewSetting")}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <AgendaFilter
                setAgendaTypes={setViewSetting}
                agendaTypes={viewSettig}
                FilterEventsData={viewSettingFilterOptions}
              />
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </>
    );
  };

  const renderFilterButtonSection = () => {
    return (
      <div className={["filter-btn-box"]}>
        <button
          className={"button button-round button-shadow mr-3"}
          title="apply"
          onClick={() => handleApply()}
        >
          {t("apply")}
        </button>
        <button
          className={"button button-round button-border button-dark reset-btn"}
          title="reset"
          onClick={() => handleReset()}
        >
          {t("reset")}
        </button>
        <button
          className={"button button-round button-border button-dark cancel-btn"}
          title="close"
          onClick={() => handleSidebarToggle()}
        >
          {t("close")}
        </button>
      </div>
    );
  };

  return (
    <StickySidebar
      isSidebarActive={isSidebarActive}
      handleSidebarToggle={handleSidebarToggle}
      resetFilter={handleReset}
    >
      {renderCalendarSection()}
      {renderFilterSection()}
      {renderFilterButtonSection()}
    </StickySidebar>
  );
};
export default withTranslation()(SchedulingAssistentFilter);
